export default __webpack_public_path__ + "static/media/9.5d40bb9e.png";